import { AcademicCareerCode } from "@anu-its/cat-grpc-pb/js/anu/cat_app/enums_pb";

export const academicCareer = (academicCareerCode: AcademicCareerCode) =>
  ({
    [AcademicCareerCode.UNSPECIFIED]: "Unspecified",
    [AcademicCareerCode.NONAWARD]: "Non Award",
    [AcademicCareerCode.POSTGRAD]: "Postgraduate",
    [AcademicCareerCode.RESEARCH]: "Research",
    [AcademicCareerCode.UNDERGRAD]: "Undergraduate",
  })[academicCareerCode];
